var $87838cfc34c13467$exports = {};
'use strict';
// Search-engine indexing policy for the provider portal.
//
// The portal is a single-page app served from one index.html, so every route
// shares the static <title>/<meta> in the document head. Googlebot executes
// this app's JS and had been indexing deep, auth-gated routes (e.g. /patients,
// /admin/charge_items) with misleading auto-generated titles. Only the landing
// page at app.hint.com/ should appear in search results; /login and every other
// route are auth-gated or onboarding flows that must stay out of the index.
//
// Googlebot fetches and renders each URL independently (it never navigates the
// SPA), so the tag only needs to be correct for the URL as it was requested.
// We evaluate ONCE here in <head>, before the Elm app boots — crucially before
// Pages.Top.init redirects "/" to "/login" (which fires a synthetic popstate
// via Ports/navigation.js). Re-deriving indexability after that redirect would
// flip the requested "/" to noindex and drop it from the index, the opposite of
// the goal. Reading the entry path once keeps "/" indexable through the
// redirect, and there's nothing to gain from reacting to later in-app
// navigation since crawlers don't trigger it.
const $87838cfc34c13467$var$INDEXABLE_PATHS = [
    '/',
    ''
];
const $87838cfc34c13467$var$indexable = $87838cfc34c13467$var$INDEXABLE_PATHS.includes(window.location.pathname);
let $87838cfc34c13467$var$meta = document.querySelector('meta[name="robots"]');
if (!$87838cfc34c13467$var$meta) {
    $87838cfc34c13467$var$meta = document.createElement('meta');
    $87838cfc34c13467$var$meta.setAttribute('name', 'robots');
    document.head.appendChild($87838cfc34c13467$var$meta);
}
$87838cfc34c13467$var$meta.setAttribute('content', $87838cfc34c13467$var$indexable ? 'index, follow' : 'noindex, follow');


//# sourceMappingURL=project.b536acd4.js.map
